<div class="loading-container">
  <div *ngIf="displayLoader" class="lds-ripple"><div></div><div></div></div>
  <h3 class="loading-message">
    {{ loadingMessage }}
  </h3>
</div>